module.exports = __webpack_public_path__ + "asset/image-ic_category_27-e22f016c960a6900.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/ic_category_27.svg
// module id = lnWs
// module chunks = 0